import React from 'react';
import { Button } from '@mui/material';
import { BiHome, BiSearchAlt } from 'react-icons/bi';
import { BsBookmarks } from 'react-icons/bs'
import { MdOutlinePostAdd } from 'react-icons/md';
import { HiOutlineLogout } from 'react-icons/hi';
import { useDispatch } from 'react-redux';
import { signOut } from 'firebase/auth';
import { authentication } from '../../services';
import { clearData } from '../../redux/actions/recipes';
import './styles.sass';

const MobileSidebar = ({ activeScreen, setActiveScreen, setOpen, showRecipe, setShowRecipe }) => {
    const dispatch = useDispatch();

    const handleInsertion = () => {
        setActiveScreen('add');
        setOpen(true);
    }

    const onSignOut = () => {
        signOut(authentication);
        setTimeout(() => {
            dispatch(clearData());
        }, 500);
    }

    return (
        <div className="mobile-sidebar-container">
            <Button
                disableRipple
                className={activeScreen === 'main' ? 'button active' : 'button inactive'}
                onClick={() => {
                    setActiveScreen('main');
                    if (showRecipe)
                        setShowRecipe(false);
                }}
            >
                <BiHome className={activeScreen === 'main' ? 'icon icon-active' : 'icon icon-inactive'} />
                {options[0]}
            </Button>
            <Button
                disableRipple
                className={activeScreen === 'favorites' ? 'button active' : 'button inactive'}
                onClick={() => {
                    setActiveScreen('favorites');
                    if (showRecipe)
                        setShowRecipe(false);
                }}
            >
                <BsBookmarks className={activeScreen === 'favorites' ? 'icon icon-active' : 'icon icon-inactive'} />
                {options[1]}
            </Button>
            <Button
                disableRipple
                className={activeScreen === 'add' ? 'button active' : 'button inactive'}
                onClick={handleInsertion}
            >
                <MdOutlinePostAdd className={activeScreen === 'add' ? 'icon icon-active' : 'icon icon-inactive'} />
                {options[2]}
            </Button>
            <Button
                disableRipple
                className={activeScreen === 'search' ? 'button active' : 'button inactive'}
                onClick={() => {
                    setActiveScreen('search');
                    if (showRecipe)
                        setShowRecipe(false);
                }}
            >
                <BiSearchAlt className={activeScreen === 'search' ? 'icon icon-active' : 'icon icon-inactive'} />
                {options[3]}
            </Button>
            <Button
                disableRipple
                className="button inactive"
                onClick={onSignOut}
            >
                <HiOutlineLogout className="icon icon-inactive" />
                {options[4]}
            </Button>
        </div>
    )
}

const options = [
    'המתכונים שלי',
    'המועדפים שלי',
    'הוספת מתכון',
    'חיפוש מתכון',
    'יציאה מהחשבון'
];

export default MobileSidebar;